import type { Images } from 'venn-ui-kit';

// eslint-disable-next-line import/no-dynamic-require
const getAsset = (asset: string) => require(`../default/assets/${asset}`); // nosemgrep: nodejs_scan.javascript-eval-rule-eval_require

export const getImageTheme = (): Images => ({
  holdingsAsset: getAsset('holdingsAsset.png'),
  privatesAsset: getAsset('privatesAsset.png'),
  privateAssetAGSConeChart: getAsset('privateAssetAGSConeChart.svg'),
  privateAssetCFPModelSettings: getAsset('cfpModelSettingsCarousel.png'),
  peerGroupAnalysisAsset: getAsset('peerGroupAnalysisAsset.png'),
  extrapolationAsset: getAsset('extrapolationAsset.png'),
  reportLabAsset: getAsset('reportLabAsset.png'),
  morningstarCategoryAsset: getAsset('morningstarCategoryAsset.png'),
  historicalAllocations: getAsset('historicalAllocations.png'),
  six: getAsset('six.png'),
  correlations: getAsset('correlations.png'),
  cumulativeResidualReturn: getAsset('cumulativeResidualReturn.png'),
  factorContributionsToExposureTrend: getAsset('factorContributionsToExposureTrend.png'),
  factorContributionsToReturnTrend: getAsset('factorContributionsToReturnTrend.png'),
  factorContributionsToRiskTrend: getAsset('factorContributionsToRiskTrend.png'),
  historicalDrawdownChart: getAsset('historicalDrawdownChart.png'),
  performanceAttribution: getAsset('performanceAttribution.png'),
  residualPerformanceSummary: getAsset('residualPerformanceSummary.png'),
  rollingReturn: getAsset('rollingReturn.png'),
  scenarioAnalysis: getAsset('scenarioAnalysis.png'),
  northernTrust: getAsset('northernTrust.svg'),
  addepar: getAsset('addepar.svg'),
  backstop: getAsset('backstop.svg'),
  bny: getAsset('bny.svg'),
  citco: getAsset('citco.svg'),
  citi: getAsset('citi.svg'),
  dynamo: getAsset('dynamo.svg'),
  jpMorgan: getAsset('jpmChase.svg'),
  mercer: getAsset('mercer.svg'),
  parilux: getAsset('parilux.svg'),
  solovis: getAsset('solovis.svg'),
  ssAndC: getAsset('ssAndC.svg'),
  stateStreet: getAsset('stateStreet.svg'),
  wilShire: getAsset('wilshire.svg'),
  rcm: getAsset('rcm.png'),
  integrationBanner: getAsset('integrationBanner.png'),
  riskReturn: getAsset('riskReturn.png'),
  scenario: getAsset('scenario.png'),
  macroScenario: getAsset('macroScenario.png'),
  portfolioLabs: getAsset('portfolioLabs.png'),
  triangles: getAsset('triangles.png'),
  trianglesRepeating: getAsset('trianglesRepeating.png'),
  trend: getAsset('trend.png'),
  credit: getAsset('credit.png'),
  factorBreakdown: getAsset('factorBreakdown.png'),
  drawdown: getAsset('drawdown.png'),
  vennProvidedLogo: getAsset('vennProvidedLogo.png'),
  vennProvidedLogoGreyscale: getAsset('vennProvidedLogoGreyscale.png'),
  vennBackground: getAsset('vennBackground.svg'),
  brandLogo: getAsset('brandLogo.svg'),
  brandLogoDark: getAsset('brandLogoDark.svg'),
  addeparStep1AddeparLogin: getAsset('addeparStep1AddeparLogin.png'),
  addeparStep1Authorization: getAsset('addeparStep1Authorization.png'),
  addeparStep2PortfolioPrefix: getAsset('addeparStep2PortfolioPrefix.png'),
  addeparStep2PortfolioName: getAsset('addeparStep2PortfolioName.png'),
  addeparStep2InvestmentName: getAsset('addeparStep2InvestmentName.png'),
  addeparStep5Sync: getAsset('addeparStep5Sync.png'),
  privateAssetLabSlideoutAsset: getAsset('privateAssetLabSlideoutAsset.png'),
  privateAssetLabSlideoutAsset2: getAsset('privateAssetLabSlideoutAsset2.png'),
  privateAssetLabCarousel: getAsset('privateAssetLabCarousel.png'),
  privateAssetLabCarouselVdpar: getAsset('privateAssetLabCarouselVdpar.png'),
  reportlabSlideoutAsset: getAsset('reportlabSlideoutAsset.png'),
  reportlabSlideoutAsset2: getAsset('reportlabSlideoutAsset2.png'),
  investmentSnapshotSlideoutAsset: getAsset('investmentSnapshotSlideoutAsset.png'),
  vennDailyPrivateAssetReturns: getAsset('vennDailyPrivateAssetReturns.svg'),
});
